import { Api } from './api';
import { BonusReason } from '../model/user-info.interface';

export class BonusesApi {
    private static readonly PATH = '/bonuses';

    constructor(private readonly m_api: Api) {}

    public async applyBonuses(reason: BonusReason) {
        return this.m_api.post(`${BonusesApi.PATH}/apply`, { reason });
    }
}
